import React from "react";
import { SneakerForm } from "../Components/SneakerForm";

export const New = () => {
  return (
    <div>
      <h3 className="text-center">Add To Our Collection</h3>
      <br />
      <SneakerForm />
    </div>
  );
};
